import { Controller } from "@hotwired/stimulus";

export default class AutoDownloadController extends Controller<HTMLElement> {
  static override values = { url: String };
  declare readonly urlValue: string;

  override connect(): void {
    this.download();
  }

  download(): void {
    const link = document.createElement("a");
    link.href = this.urlValue;
    link.download = "";
    link.click();
  }
}
